module.exports = __webpack_public_path__ + "img/logo_hoopla_white.52f90e69.png";